export const setNumberOfItems = (numberOfItemsKey, numberOfItems) => {
  if (localStorage.getItem(numberOfItemsKey) == null || localStorage.getItem(numberOfItemsKey) == undefined) {
    localStorage.setItem(numberOfItemsKey, numberOfItems);
  }
};
